export function JsonBlock({ value }: { value: unknown }) {
  if (value == null) {
    return <p className="text-sm text-muted-foreground">Нет данных</p>;
  }

  return (
    <pre className="mono-block">
      {JSON.stringify(value, null, 2)}
    </pre>
  );
}
